import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface LoginProps {
  onLogin: (username: string, password: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export default function SimpleLogin({ onLogin, loading, error }: LoginProps) {
  const [form] = Form.useForm();
  const [sessionExpired, setSessionExpired] = useState(false);

  // 세션 만료 플래그 확인
  useEffect(() => {
    if (typeof sessionStorage !== 'undefined') {
      const expired = sessionStorage.getItem('session_expired');
      if (expired === 'true') {
        setSessionExpired(true);
        // 플래그 제거 (한 번만 표시)
        sessionStorage.removeItem('session_expired');
      }
    }
  }, []);

  const handleSubmit = async (values: { username: string; password: string }) => {
    // 로그인 시도 시 세션 만료 메시지 숨김
    setSessionExpired(false);
    await onLogin(values.username, values.password);
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '16px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card style={{ 
        width: '100%',
        maxWidth: 440,
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)' 
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🚌</div>
          <Title level={2} style={{ margin: 0 }}>관리자 로그인</Title>
          <p style={{ color: '#666', marginTop: 8 }}>
            버스 내비게이션 시스템
          </p>
        </div>

        {sessionExpired && (
          <Alert
            message="세션이 만료되었습니다"
            description="보안을 위해 자동으로 로그아웃되었습니다. 다시 로그인해주세요."
            type="warning"
            showIcon
            closable
            onClose={() => setSessionExpired(false)}
            style={{ marginBottom: 16 }}
          />
        )}

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Form
          form={form}
          name="login"
          onFinish={handleSubmit}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '사용자명을 입력해주세요!' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="사용자명"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '비밀번호를 입력해주세요!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="비밀번호"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 45 }}
            >
              로그인
            </Button>
          </Form.Item>
        </Form>

      </Card>
    </div>
  );
}